export const workbooksConstants = {
  FETCH_LESSON_ITEM_BANK: "FETCH_LESSON_ITEM_BANK",
  FETCH_LESSON_ITEM_BANK_SUCCESS: "FETCH_LESSON_ITEM_BANK_SUCCESS",
  FETCH_LESSON_ITEM_BANK_FAILURE: "FETCH_LESSON_ITEM_BANK_FAILURE",

  FETCH_ACT_SUBCOURSES: "FETCH_ACT_SUBCOURSES",
  FETCH_ACT_SUBCOURSES_SUCCESS: "FETCH_ACT_SUBCOURSES_SUCCESS",
  FETCH_ACT_SUBCOURSES_FAILURE: "FETCH_ACT_SUBCOURSES_FAILURE",

  FETCH_LESSONS: "FETCH_LESSONS",
  FETCH_LESSONS_SUCCESS: "FETCH_LESSONS_SUCCESS",
  FETCH_LESSONS_FAILURE: "FETCH_LESSONS_FAILURE",

  FETCH_ALL_LESSON_DECKS_REQUEST: "FETCH_ALL_LESSON_DECKS_REQUEST",
  FETCH_ALL_LESSON_DECKS_SUCCESS: "FETCH_ALL_LESSON_DECKS_SUCCESS",
  FETCH_ALL_LESSON_DECKS_FAILURE: "FETCH_ALL_LESSON_DECKS_FAILURE",

  FETCH_LESSON_STUDENTS_REQUEST: "FETCH_LESSON_STUDENTS_REQUEST",
  FETCH_LESSON_STUDENTS_SUCCESS: "FETCH_LESSON_STUDENTS_SUCCESS",
  FETCH_LESSON_STUDENTS_FAILURE: "FETCH_LESSON_STUDENTS_FAILURE",

  FETCH_ITEM_BANKS_STUDENTS_REQUEST: "FETCH_ITEM_BANKS_STUDENTS_REQUEST",
  FETCH_ITEM_BANKS_STUDENTS_SUCCESS: "FETCH_ITEM_BANKS_STUDENTS_SUCCESS",
  FETCH_ITEM_BANKS_STUDENTS_FAILURE: "FETCH_ITEM_BANKS_STUDENTS_FAILURE",

  SET_EXIT_TICKET_SCORE_REQUEST: "SET_EXIT_TICKET_SCORE_REQUEST",
  SET_EXIT_TICKET_SCORE_SUCCESS: "SET_EXIT_TICKET_SCORE_SUCCESS",
  SET_EXIT_TICKET_SCORE_FAILURE: "SET_EXIT_TICKET_SCORE_FAILURE",

  RESET_STUDENT_EXIT_TICKET_REQUEST: "RESET_STUDENT_EXIT_TICKET_REQUEST",
  RESET_STUDENT_EXIT_TICKET_SUCCESS: "RESET_STUDENT_EXIT_TICKET_SUCCESS",
  RESET_STUDENT_EXIT_TICKET_FAILURE: "RESET_STUDENT_EXIT_TICKET_FAILURE",

  TOGGLE_GROUP_LESSON_STATUS: "TOGGLE_GROUP_LESSON_STATUS",
  TOGGLE_STUDENT_LESSON_STATUS: "TOGGLE_STUDENT_LESSON_STATUS",
  TOGGLE_GROUP_LESSON_STATUS_SUCCESS: "TOGGLE_GROUP_LESSON_STATUS_SUCCESS",
  TOGGLE_STUDENT_LESSON_STATUS_SUCCESS: "TOGGLE_STUDENT_LESSON_STATUS_SUCCESS",
  TOGGLE_GROUP_LESSON_STATUS_FAILURE: "TOGGLE_GROUP_LESSON_STATUS_FAILURE",
  TOGGLE_STUDENT_LESSON_STATUS_FAILURE: "TOGGLE_GROUP_LESSON_STATUS_FAILURE",

  TOGGLE_ALL_GROUP_LESSON_STATUS: "TOGGLE_ALL_GROUP_LESSON_STATUS",
  TOGGLE_ALL_STUDENT_LESSON_STATUS: "TOGGLE_ALL_STUDENT_LESSON_STATUS",
  TOGGLE_ALL_GROUP_LESSON_STATUS_SUCCESS:
    "TOGGLE_ALL_GROUP_LESSON_STATUS_SUCCESS",
  TOGGLE_ALL_STUDENT_LESSON_STATUS_SUCCESS:
    "TOGGLE_ALL_STUDENT_LESSON_STATUS_SUCCESS",
  TOGGLE_ALL_GROUP_LESSON_STATUS_FAILURE:
    "TOGGLE_ALL_GROUP_LESSON_STATUS_FAILURE",
  TOGGLE_ALL_STUDENT_LESSON_STATUS_FAILURE:
    "TOGGLE_ALL_GROUP_LESSON_STATUS_FAILURE",

  TOGGLE_GROUP_LESSON_COMPLETE: "TOGGLE_GROUP_LESSON_COMPLETE",
  TOGGLE_STUDENT_LESSON_COMPLETE: "TOGGLE_STUDENT_LESSON_COMPLETE",
  TOGGLE_GROUP_LESSON_COMPLETE_SUCCESS: "TOGGLE_GROUP_LESSON_COMPLETE_SUCCESS",
  TOGGLE_STUDENT_LESSON_COMPLETE_SUCCESS:
    "TOGGLE_STUDENT_LESSON_COMPLETE_SUCCESS",
  TOGGLE_GROUP_LESSON_COMPLETE_FAILURE: "TOGGLE_GROUP_LESSON_COMPLETE_FAILURE",
  TOGGLE_STUDENT_LESSON_COMPLETE_FAILURE:
    "TOGGLE_GROUP_LESSON_COMPLETE_FAILURE",

  REFRESH_GCP: "REFRESH_GCP",
  REFRESH_GCP_SUCCESS: "REFRESH_GCP_SUCCESS",
  REFRESH_GCP_FAILURE: "REFRESH_GCP_FAILURE",

  FETCH_ACTIVE_COURSE: "FETCH_ACTIVE_COURSE",
  FETCH_ACTIVE_COURSE_SUCCESS: "FETCH_ACTIVE_COURSE_SUCCESS",
  FETCH_ACTIVE_COURSE_FAILURE: "FETCH_ACTIVE_COURSE_FAILURE",
  FETCH_LESSIONSECTION_SUCCESS: "FETCH_LESSIONSECTION_SUCCESS",

  CLEAR_COURSE: "CLEAR_COURSE",
  CLEAR_SUBCOURSES: "CLEAR_SUBCOURSES"
}
